<template>
	<v-text-field
		dense
		ref="name"
		single-line
		width="100%"
		hide-details
		v-model="textLocal"
		data-lpignore="true"
		:disabled="localDisabled"
		@keydown.enter="() => !dontSaveOnEnter && saveName()"
		:placeholder="placeholder"
		@keydown.esc="revertRename"
		@click.native.stop="onClick"
		:class="{ disabled: localDisabled }"
		@blur="() => !dontSaveOnBlur && saveName()"
		class="editable-text-field text-overflow-ellipsis"
	>
		<template v-slot:append>
			<slot name="append" />
		</template>
	</v-text-field>
</template>

<script>
export default {
	name: 'EditableTextField',
	props: {
		text: { type: String },
		isEditing: { type: Boolean },
		disabled: { type: Boolean },
		placeholder: { type: String },
		dontSaveOnBlur: { type: Boolean },
		dontSaveOnEnter: { type: Boolean },
		isEditOnClick: { type: Boolean, default: false },
	},
	computed: {
		isEditingLocal: {
			set(value) {
				this.$emit('update:isEditing', value);
			},
			get() {
				return this.isEditing;
			},
		},
		localDisabled() {
			return (!this.isEditingLocal && !this.isEditOnClick) || this.disabled;
		},
	},
	methods: {
		revertRename() {
			this.textLocal = this.text;
			this.isEditingLocal = false;
		},
		onDelete() {
			this.textLocal = '';
			this.saveName();
		},
		saveName() {
			this.$emit('onSave', this.textLocal);
			this.isEditingLocal = false;
		},
		onClick() {
			if (this.isEditOnClick) {
				this.isEditingLocal = true;
			}
		},
		blur() {
			this.$refs.name.blur();
		},
		focus() {
			this.$refs.name.focus();
		},
	},
	watch: {
		text: {
			handler(newV) {
				this.textLocal = newV;
			},
			immediate: true,
			deep: true,
		},
		isEditingLocal: {
			handler(newV) {
				if (newV) {
					this.$nextTick(() => {
						this.$refs.name.focus();
					});
				}
			},
		},
	},
	data() {
		return {
			textLocal: '',
		};
	},
};
</script>

<style scoped lang="scss">
.editable-text-field {
	&.disabled {
		pointer-events: none;
	}
	&::v-deep {
		&.v-text-field {
			> .v-input__control > .v-input__slot {
				&:before {
					border-color: rgba(0, 0, 0, 0.42);
					border: none;
				}
				&:after {
					border-width: 1px !important;
				}
			}
			&.v-input--is-disabled,
			&.v-input--is-disabled input {
				color: #3e495a !important;
				opacity: 1 !important;
			}
		}
	}
}
</style>
